import { render, staticRenderFns } from "./minePage.vue?vue&type=template&id=3654811a&scoped=true&"
import script from "./minePage.vue?vue&type=script&lang=js&"
export * from "./minePage.vue?vue&type=script&lang=js&"
import style0 from "./minePage.vue?vue&type=style&index=0&id=3654811a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3654811a",
  null
  
)

export default component.exports